/**
 * userpreferencesreducer.js
 * Created by calhosh on 8/28/2020.
 */
import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function timezonesReducer(state = initialState.timezones, action) {
	switch (action.type) {
		case types.GET_TIMEZONES: {
			return action.response;
		}
		default:
			return state;
	}
}
